<template>
  <reference-layout>
    <template #header>
      <reference-header header-title="Документы">
        <template #header-title-action>
          <!-- <div class="layout-header-action">
            <c-button
              size="small"
              :icon="{
                icon: 'bookmark',
                activeColor: 'white',
              }"
              :tooltip="{
                text: 'Добавить в закладки',
                activeText: 'Убрать из закладок',
              }"
              active-color="blue"
              :active="bookmark"
              @click="bookmark = !bookmark"
            />
          </div> -->
        </template>
        <template #header-actions>
          <div class="layout-header-action">
            <c-button-2
              size="small"
              label="Новый тип"
              :icon="{
                icon: 'plus',
                color: 'blue',
              }"
              @click="createDocumentType"
            />
          </div>

          <div class="layout-header-action">
            <c-button-2
              size="small"
              label="Новый документ"
              :icon="{
                icon: 'plus',
                color: 'blue',
              }"
              @click="createDocument"
            />
          </div>
        </template>
      </reference-header>
    </template>

    <template #subheader>
      <div class="documents-page__search">
        <c-input v-model="query" placeholder="Поиск" type="text" :clearable="true" icon="search" />
      </div>
    </template>

    <template #list>
      <c-switcher
        v-model="documentSelectedItem"
        :items="documentsSwitchItems"
        class="h-switcher documents-switch"
        type="group"
      />

      <documents-list ref="list" :query="query" :selected-tab="documentSelectedItem"></documents-list>
    </template>
  </reference-layout>
</template>

<script>
import VueCookies from "vue-cookies";
import Vue from "vue";
import ReferenceLayout from "@/layouts/reference-layout";
import ReferenceHeader from "@/components/reference-components/reference-header";
import DocumentsList from "@/pages/documents/documents-list";

import Button from "@/components/controls2/Button";
import button from "@/components/controls/button";
import Input from "@/components/controls2/Input";
import Switcher from "@/components/controls/switcher";

Vue.use(VueCookies);

const SwitcherItems = [
  {
    label: "Действующие",
    value: "0",
  },
  {
    label: "Архив",
    value: "1",
  },
];

export default {
  name: "documents",

  components: {
    "c-switcher": Switcher,
    "c-button": Button,
    "c-button-2": button,
    "c-input": Input,
    "documents-list": DocumentsList,
    ReferenceLayout,
    ReferenceHeader,
  },

  data() {
    return {
      bookmark: false,
      query: "",
      documentSelectedItem: "0",
      documentsSwitchItems: SwitcherItems,
    };
  },

  methods: {
    createDocumentType() {
      this.$refs.list.addGroup();
    },
    createDocument() {
      this.$router.push({
        name: "create-document",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .layout {
  @media (max-width: 480px) {
    padding: 28px 0 50px 0;
  }
}
.documents-page {
  &__search {
    margin-bottom: 20px;
    max-width: 564px;
    flex-grow: 1;

    & /deep/ {
      input::placeholder {
        font-style: italic;
      }
    }
  }
}

.documents-switch {
  margin-bottom: 24px;
}
</style>
